import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { List } from 'foundations-components/transitional/components/List';
import FileAttachment from '../../files/FileAttachment';
import { useFetchBatchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { isError, isLoading } from 'reference-resolvers-lite/Status';
import styled from 'styled-components';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { useMemo } from 'react';
import FileValuesUnresolvedList from '../../files/values/FileUnresolvedValuesList';
import { getMissingReferences } from '../../files/utils';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFileAttachment = styled(FileAttachment).withConfig({
  displayName: "FormattedPropertyFiles__StyledFileAttachment",
  componentId: "mqh872-0"
})(["padding-left:0px;"]);
const FormattedPropertyFiles = props => {
  const propertyValue = usePropertyValue();
  const {
    placeholder,
    resolver
  } = props;
  useComponentMountMetric('FormattedPropertyFiles');
  const fileIds = parseMultiEnumValue(propertyValue);
  const {
    references: fileReferences,
    status
  } = useFetchBatchResolver(resolver, fileIds);
  const missingReferences = useMemo(() => isError(status) ? fileIds : getMissingReferences(fileReferences, fileIds), [fileIds, fileReferences, status]);
  if (isLoading(status)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small"
    });
  }
  const emptyFileReferences = !fileReferences || fileReferences.length === 0;
  if (emptyFileReferences && missingReferences.length === 0) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: placeholder
    });
  }
  return /*#__PURE__*/_jsxs("span", Object.assign({}, getDataAttributes(props), {
    children: [/*#__PURE__*/_jsx(List, {
      children: fileReferences && fileReferences.map(fileReference => /*#__PURE__*/_jsx(StyledFileAttachment, {
        fileReference: fileReference
      }, fileReference.id))
    }), missingReferences.length > 0 && /*#__PURE__*/_jsx(FileValuesUnresolvedList, {
      missingFileReferences: missingReferences,
      isEditDisabled: true,
      showRemoveAction: false
    })]
  }));
};
export default FormattedPropertyFiles;